export const CollarType = Object.freeze({
    NORMAL: 1,
    EXIT: 2,
});